import { render, staticRenderFns } from "./PoliciesHeader.vue?vue&type=template&id=b1b57ba4&scoped=true&"
import script from "./PoliciesHeader.vue?vue&type=script&lang=js&"
export * from "./PoliciesHeader.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesHeader.vue?vue&type=style&index=0&id=b1b57ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b57ba4",
  null
  
)

export default component.exports